/** Key type is limited due to https://github.com/microsoft/TypeScript/pull/37457 */
export function mapValues(obj, fn) {
    return Object.fromEntries(Object.entries(obj).map(([k, v]) => [k, fn(v)]));
}
